module.exports = __webpack_public_path__ + "static/media/72.56b1b66d.jpg";